import * as cn from "classnames";
import * as React from "react";
import "./ReportsLayout.css";

export interface ReportLabelProps {
    title: string;
    subtitle?: string;
    className?: string;
}

export function ReportLabel(props: ReportLabelProps) {
    return (
        <span className={cn("report-label", props.className)}>
            <span className="report-label__title">{props.title}</span>
            <span className="report-label__subtitle">{props.subtitle || ""}</span>
        </span>
    );
}
